// extracted by mini-css-extract-plugin
export default {"parent":"carousel_parent__vmWeA","child":"carousel_child__hwhzZ","line":"carousel_line__IglzL"};